/* global google */

import alertify from "alertifyjs";
import { initRecording } from "./recording";
import { isMobile, isAndroid, isiOS, isChrome, isSafari, browser } from "./responsive";
import { roundware, ROUNDWARE_INITIAL_LATITUDE, ROUNDWARE_INITIAL_LONGITUDE } from "./roundware";
import { CoronaDiariesMapStyle } from "./map-style";
var $ = window.jQuery = require("jquery");
require("gasparesganga-jquery-loading-overlay");

// BROWSER SENSING
console.log(browser);
// First sense mobile/desktop, then sense platform
if (isMobile) {
  console.log("Mobile/tablet device detected");
  // $("#menu-listen").hide();
  if (isiOS) {
    console.log("iOS device detected");
    const message = "Are you at Manzanar or Little Tokyo? If so, download our iOS app so you can explore the on-site experience."
    alertify.confirm('<strong>One Square Mile Info</strong>', message, function(){
      window.location.href = 'https://apps.apple.com/us/app/one-square-mile/id1460199702';
    }, function(){
        window.location.href = '/index.html';
    }).set({
      transition:'zoom',
      closable: false,
      defaultFocusOff: true,
      labels:{
        ok:'Get iOS App',
        cancel: 'Continue on website'
      },
    })
  }
  else if (isAndroid) {
    console.log("Mobile Android browser detected");
    const message = "Are you at Manzanar or Little Tokyo? If so, use the web app to explore the on-site experience."
    alertify.confirm('<strong>One Square Mile Info</strong>', message, function(){
      window.location.href = 'https://app.onesquaremile.fm';
    }, function(){
        window.location.href = '/index.html';
    }).set({
      transition:'zoom',
      closable: false,
      defaultFocusOff: true,
      labels:{
        ok:'Use web app',
        cancel: 'Continue on website'
      },
    })
  } else if (isAndroid && !isChrome) {
    console.log("Mobile Android non-Chrome browser detected");
    const message = "Sorry, the browser you’re using isn’t supported yet. Some of our features might not work as intended. We recommend you switch to Chrome."
    alertify.alert('<strong>One Square Mile Warning</strong>', message, function() {
      // alertify.message('OK');
    }).set({
      transition: 'none',
      closable: false,
      defaultFocusOff: true
    });
  } else {
    console.log("Other mobile device detected");
  }
} else {
    console.log("Desktop device detected");
    if (isChrome) {
      console.log("Chrome desktop detected");
    } else if (isSafari) {
      console.log("Safari desktop detected");
      const message = "Sorry, Safari isn't officially supported yet for listening. We recommend you switch to Chrome or Firefox."
      alertify.alert('<strong>One Square Mile Warning</strong>', message, function(){
        // location.replace("index.html");
        // location.assign(location.origin + "/index.html")
        console.log("Forwarding to home page.");
        // window.location.href = './index.html';
      }).set({
        transition:'none',
        closable: false,
        defaultFocusOff: true
      });
    } else {
      console.log("Other desktop browser detected");
    }
}

// Safari restrictions on BOTH mobile and desktop
if (isSafari) {
    console.log("Safari browser detected");
    $("#inputmeter").hide();
}

const roundwareConnectionPromise = new Promise((resolve, reject) => {
  roundware.
    connect().
    then(connectParams => resolve(connectParams)).
    catch(err => {
      console.error('Roundware unable to connect', err);
      reject('We were unable to connect to Roundware due to error, please try again.');
    });
});

// $("#mapbox").LoadingOverlay("show", {
//     background  : "rgba(0, 0, 0, 0.7)",
// 		text        : "Loading voices...",
// 		textColor		: "#cccccc",
// 		imageColor	: "#cccccc",
// 		maxSize			: "80px"
// });

const listenMapEl = document.getElementById('loading-test');
if (!isiOS && !isAndroid) {
  initDemo();
}

/**
 * Calculates the distance between two {@link Point|points} in degress, radians,
 * miles, or kilometers. This uses the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula)
 * to account for global curvature.
 *
 * Modified from https://github.com/Turfjs/turf-distance/blob/a79f9dcc4402e0244fbcd3b7f36d9b361d9032bf/index.js */
function distance(coordinates1,coordinates2) {
  const dLat = toRad(coordinates2[1] - coordinates1[1]);
  const dLon = toRad(coordinates2[0] - coordinates1[0]);
  const lat1 = toRad(coordinates1[1]);
  const lat2 = toRad(coordinates2[1]);

  const a = Math.pow(Math.sin(dLat/2), 2) +
            Math.pow(Math.sin(dLon/2), 2) * Math.cos(lat1) * Math.cos(lat2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

  const distanceInKm = 6373 * c;
  return distanceInKm;
}

function toRad(degree) {
  return degree * Math.PI / 180;
}

function mapSpeakers(map,roundware) {
  const speakers = roundware.speakers();

  speakers.forEach(item => {
    map.data.addGeoJson({
      "type": "Feature",
      "geometry": item.shape,
      "properties": {
        "speaker_id": item.id,
        "title": "outer"
      }
    });

    map.data.addGeoJson({
      "type": "Feature",
      "geometry": item.attenuation_border,
      "properties": {
        "speaker_id": item.id,
        "title": "inner"
      }
    });

    map.data.setStyle(function(feature) {
      if (feature.getProperty('name') == "outer") {
        return {
          fillColor: '#aaaaaa',
          fillOpacity: .5,
          strokeWeight: 1,
          strokeOpacity: .5
        };
      }
      else if (feature.getProperty('name') == "inner") {
        return {
          fillColor: '#555555',
          fillOpacity: 0,
          strokeWeight: 1,
          strokeOpacity: .2
        };
      }
    });
  });
}

const MARKER_IMG_SRC = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png';

function mapAssets(map,listener,roundware) {
  const assets = roundware.assets();
  console.log(assets);
  const assetMarkers = [];
  const markerImg = new google.maps.MarkerImage(MARKER_IMG_SRC);

  assets.forEach(item => {
    const point = new google.maps.LatLng(item.latitude,item.longitude);

    const marker = new google.maps.Marker({
      map,
      position: point,
      icon: markerImg
    });

    marker.id = item.id;
    marker.rw_tags = [];

    if (item.tag_ids) {
      marker.rw_tags = item.tag_ids;
    }

    const { id: itemId, file, volume, created = '', weight, tag_ids } = item;

    const content = `
    <p><b>Asset ${itemId}</b></br>
    <em>${file}</em></br></p>
    <table>
      <tr><th>Volume</th><td>${volume}</td></tr>
      <tr><th>Created</th><td>${created.slice(0,19)}</td></tr>
      <tr><th>Weight</th><td>${weight}</td></tr>
      <tr><th>Tags</th><td>${tag_ids}</td></tr>
    </table>`;

    const infoWindow = new google.maps.InfoWindow({ content });

    marker.addListener('click', function() {
      infoWindow.open(map,marker);

      const assetLocationPoint = [
        marker.position.lng(),
        marker.position.lat()
      ];

      const listenerLocationPoint = [
        listener.position.lng(),
        listener.position.lat()
      ];

      const dist = distance(listenerLocationPoint,assetLocationPoint);

      console.info(`Asset #${marker.id}: ${dist.toFixed(1)}m from listener`);
    });

    // display asset shape if exists
    if (item.shape) {
      marker.shape = new google.maps.Data();
      marker.shape.addGeoJson({
        "type": "Feature",
        "geometry": item.shape,
        "properties": {
          "asset_id": item.id,
          "name": "assetRange"
        }
      });

      marker.shape.setStyle(feature => {
        if (feature.getProperty('name') === "assetRange") {
          return {
            fillColor: '#6292CF',
            fillOpacity: .25,
            strokeWeight: 1,
            strokeOpacity: .8,
            strokeColor: '#6292CF'
          };
        } else {
          return {};
        }
      });
    } else {
      // if no asset shape, display default circle range
      const circle = {
        strokeColor: '#6292CF',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#6292CF',
        fillOpacity: 0.25,
        map: map,
        center: new google.maps.LatLng(item.latitude, item.longitude),
        radius: roundware._project.recordingRadius
      };

      marker.circle = new google.maps.Circle(circle);
    }

    assetMarkers.push(marker);
  });

  return assetMarkers;
}

function showHideMarkers(map,assetMarkers) {
  assetMarkers.forEach(item => {
    // if any item tags are not included in selected tags, hide marker, otherwise show it
    //const selectedListenTagIds = $("#uiListenDisplay input:checked").map(function() {
      //return Number(this.value);
    //}).get();

    //let is_visible = true;

    //const { rw_tags = [] } = item;

    //rw_tags.forEach((j,tag_id) =>{
    //// if tag_id isn't selected, set to false and return
    //if (!(selectedListenTagIds.includes(tag_id))) {
    //is_visible = false;
    //return;
    //}
    //});

    const is_visible = true;

    item.setVisible(is_visible);

    if (item.circle) {
      item.circle.setVisible(is_visible);
    }
    if (item.shape) {
      if (is_visible) {
        item.shape.setMap(map);
      } else if (!is_visible) {
        item.shape.setMap(null);
      }
    }
  });
}

const drawListeningCircle = (map,center,radius) => (
  new google.maps.Circle({
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    map,
    center,
    radius
  })
);

async function initDemo() {
  console.log("init started");
  var mixer = {};
  const message = 'More than 10,000 Japanese Americans were held at Manzanar War Relocation Center \
                   during World War II, crowded into one square mile and surrounded by barbed wire. \
                   Torn away from their homes, they endured isolation, deprivation, and the harsh \
                   desert environment. Yet they also continued their lives as best they could, working, \
                   playing, and building a community. <br><br><strong>Click START and then the pink squares to explore their stories.</strong>'
  if (!alertify.listenLoading) {
    alertify.dialog('listenLoading', function factory() {
        return {
          build: function() {
            this.elements.footer.id = "footerElement";
          }
        };
    }, false, 'alert');
  }
  alertify.listenLoading('<div id="loading-test"><strong>One Square Mile</strong></div>', message).set({
    transition: 'none',
    closable: false,
    defaultFocusOff: true,
    onclose: function(){
      $("page-wrapper").css("background-image", "none");
      const isPlaying = mixer.toggle();
      playPauseBtn.textContent = isPlaying ? 'Pause' : 'Play';
      // start playback on Entrance
      mixer.updateParams({ minDist: 0,
                           maxDist: 100,
                           listenerLocation: {latitude: 36.727971,
                                              longitude: -118.147509 }
                         });

    }
  }).set('label', '<i class="fa fa-play"></i>Start');

  // <button id="playPauseBtn" class="button" ><i class="fa fa-play"></i> Start</button>

  // alertify.alert('<div id="loading-test"><strong>One Square Mile</strong></div>', message, function() {
  //   // alertify.message('OK');
  // }).set({
  //   transition: 'zoom',
  //   closable: false,
  //   defaultFocusOff: true
  // }).set('label', '<div id="alertLabel">Got It</div>');

  const playPauseBtn = document.getElementById('playPauseBtn');
  const skipButton = document.getElementById('skipButton');
  // const playAgainButton = document.getElementById('playAgainButton');
  // const transportBtn = document.getElementById('transportBtn');

  // display overlay instructions
  $(document.getElementById('footerElement')).LoadingOverlay("show", {
    background: "rgba(0, 0, 0, 0.95)",
    text: "Loading...",
    textColor: "#cccccc",
    textResizeFactor: 0.75,
    // imageColor: "#cccccc",
    image: "",
    fontawesome : "fa fa-cog fa-spin",
    fontawesomeColor: "#ffffff",
    fontawesomeOrder: 5,
    direction: "row",
    maxSize: "60px"
  });
  // setTimeout(function(){
  //   $(listenMapEl).LoadingOverlay("hide", true);
  //   console.log("hide map overlay");
  // }, 2000);

  try {
    const { uiConfig } = await roundwareConnectionPromise;
    // mapSpeakers(map,roundware);
    mixer = await roundware.activateMixer();
    console.log("mixer activated and ready");
    mixer.updateParams({ minDist: 0,
                         maxDist: 100,
                         listenerLocation: {latitude: 36.727600,
                                            longitude: -118.142604 }
                       });



    // const assetMarkers = mapAssets(map, oms, listener);

    const { recordingRadius = 25 } = roundware.mixParams;

    // let listeningCircle = drawListeningCircle(map,googleMapsCenter,recordingRadius);

    // const updateMapFromPosition = position => {
    //   // mixer.toggle();
    //   // listeningCircle.setMap(null);
    //   map.setCenter(position);
    //   // listeningCircle = drawListeningCircle(map,position,recordingRadius);
    // };
    //
    // const updateMapFromGeolocation = location => {
    //   const { latitude: lat, longitude: lng } = location;
    //   const position = { lat, lng };
    //   updateMapFromPosition(position, recordingRadius);
    // };
    //
    // google.maps.event.addListener(listener, "dragend", () => {
    //   const position = listener.getPosition();
    //   const latitude = position.lat();
    //   const longitude = position.lng();
    //
    //   roundware.disableGeolocation();
    //   roundware.updateLocation({ latitude, longitude });
    //   updateMapFromPosition(position);
    // });
    //
    // roundware.onUpdateLocation = listenerLocation => {
    //   // updateMapFromGeolocation(listenerLocation);
    // };

    playPauseBtn.addEventListener('click', () => {
      const isPlaying = mixer.toggle();
      playPauseBtn.textContent = isPlaying ? 'Pause' : 'Play';
    });

    skipButton.addEventListener('click', () => {
      mixer.skipTrack(39);
      mixer.skipTrack(40);
    });



    // playAgainButton.addEventListener('click', () => {
    //   mixer.replayTrack(39);
    //   mixer.replayTrack(40);
    // });



    // const tagDiv = document.getElementById("tagSelection");

    // const { listen: listenTags } = uiConfig;
    //
    // listenTags.forEach(tag => {
    //   const { header_display_text, display_items } = tag;
    //
    //   tagDiv.insertAdjacentHTML('afterbegin', `<h2>${header_display_text}</h2>`);
    //
    //   const checkboxEls = display_items.map(item => {
    //     const { tag_id, tag_display_text, default_state } = item;
    //     const checkedAttrib = default_state ? 'checked' : '';
    //
    //     return `
    //       < label >
    //       <input id='tag_checkbox_${tag_id}' type='checkbox' name='tags' value='${tag_id}' ${checkedAttrib} />
    //     ${ tag_display_text} (#${tag_id})
    //       </label >
    //     <br />
    //   `;
    //   });
    //
    //   tagDiv.insertAdjacentHTML('beforeend', checkboxEls.join('\n'));
    //   // tagDiv.style.display = 'block';
    // });

    // playPauseBtn.style.display = 'block';
    // transportBtn.style.display = 'block';

    // tagDiv.addEventListener('input', () => {
    //   const listenTagIds = [...tagDiv.querySelectorAll('[name=tags]:checked')].map(tag => tag.value);
    //   mixer.updateParams({ listenTagIds });
    // });
    initMap(mixer);
  } catch (err) {
    const errBox = document.getElementById('errorDisplay');
    errBox.style.display = 'block';
    errBox.appendChild(document.createTextNode(err));
    console.error(err);
  }
}

// Initialize Mapbox and the custom overlay.
function initMap(mixer) {
  console.log("initMap");

  mapboxgl.accessToken = 'pk.eyJ1IjoiaGJ1cmd1bmQiLCJhIjoiY2s2bWw2enMxMDBoZzNma3UwcGU0cXdsOSJ9.EYmjBurOCXiutYAq5e-q-Q';
  var map = new mapboxgl.Map({
    container: 'mapbox', // container id
    // style: 'mapbox://styles/hburgund/ck6mog98v1buk1ipfhhm4wi0n', // stylesheet location
    style: 'mapbox://styles/hburgund/ckdg85dvg171f1iqjy0ohmkyy', // transparent stylesheet location
    center: [ROUNDWARE_INITIAL_LONGITUDE, ROUNDWARE_INITIAL_LATITUDE], // starting position [lng, lat];
    zoom: 16, // starting zoom
    pitch: 60, // pitch in degrees
    bearing: -121, // bearing in degrees
    minZoom: 10,
    maxZoom: 18
  });

  // Listening locations array
  var geojson = {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-118.147509, 36.727971]
      },
      properties: {
        title: 'Entrance',
        description: 'Hear former incarcerees’ first impressions as they arrived to freezing \
                      temperatures, unfinished barracks, and dust storms, as well as WWII news \
                      reports and government propaganda leading up to the creation of the camp.',
        markerURL: "https://halseyburgund.com/dev/manz/images/osm-marker-anim-sm-6b.png"
      }
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-118.162437, 36.725460]
      },
      properties: {
        title: 'Cemetery',
        description: '150 men, women, and children died at Manzanar; 15 were laid to rest in this cemetery. \
                      Each year, participants in the Manzanar Pilgrimage gather here to honor those who died, \
                      and to reflect on the site’s legacy.',
        markerURL: "https://halseyburgund.com/dev/manz/images/osm-marker-anim-sm-5b.png"
      }
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-118.150751, 36.727793]
      },
      properties: {
        title: 'Mess Hall',
        description: 'Detainees lined up three times a day to eat at their mess hall. Mess halls \
                      were also the center of community life at Manzanar, hosting movies, meetings, \
                      and dances. Today, a reconstructed mess hall continues to be a space for \
                      gathering and discussion.',
        markerURL: "https://halseyburgund.com/dev/manz/images/osm-marker-anim-sm-3b.png"
      }
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-118.153898, 36.724645]
      },
      properties: {
        title: 'Judo Dojo',
        description: 'When not working or attending school, many people found time for sports, \
                      including basketball, kendo, and multiple baseball leagues. There were over \
                      400 students at this open-air dojo.',
        markerURL: "https://halseyburgund.com/dev/manz/images/osm-marker-anim-sm-2b.png"
      }
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-118.161250, 36.727805]
      },
      properties: {
        title: 'Hospital',
        description: 'Despite the harsh conditions of the camp, a predominantly Japanese American \
                      medical staff provided free healthcare to all who were incarcerated. From \
                      births to medical emergencies, hear the stories of doctors, nurses, and patients.',
        markerURL: "https://halseyburgund.com/dev/manz/images/osm-marker-anim-sm-4b.png"
      }
    }]
  };

  // add markers to map
  geojson.features.forEach(function(marker) {

    // create a DOM element for the marker
    var el = document.createElement('div');
    el.className = 'marker';
    // console.log('bg_image = ' + marker.properties.markerURL);
    el.style.backgroundImage = 'url(' + marker.properties.markerURL + ')';
    el.style.width = '50px';
    el.style.height = '50px';

    // Action when listening location is clicked
    el.addEventListener('click', function() {
      // start playback if not already going
      // const mixer = roundware.activateMixer();
      if (!mixer.playing) {
        const isPlaying = mixer.toggle();
        playPauseBtn.textContent = isPlaying ? 'Pause' : 'Play';
      }

      // roundware.updateLocation({
      //   latitude: marker.geometry.coordinates[1],
      //   longitude: marker.geometry.coordinates[0]
      // });

      mixer.updateParams({ minDist: 0,
                           maxDist: 100,
                           listenerLocation: {latitude: marker.geometry.coordinates[1],
                                              longitude: marker.geometry.coordinates[0] }
                         });
      mixer.skipTrack(39);
      mixer.skipTrack(40);
      // roundware.skip() to next voice right away
      roundware.disableGeolocation();
      console.log(marker.geometry.coordinates);
      map.flyTo({ center: [marker.geometry.coordinates[0],
                           marker.geometry.coordinates[1]],
                           zoom: 17
      });
    });

    // make a marker for each feature and add to the map
    new mapboxgl.Marker(el)
      .setLngLat(marker.geometry.coordinates)
      .setPopup(new mapboxgl.Popup({ offset: 25 }) // add popups
        // .setHTML('<h3>' + marker.properties.title + '</h3><p>' + marker.properties.description + '</p>'))
        .setHTML('<h3>' + marker.properties.title + '</h3>' +
                 '<p>' + marker.properties.description + '</p>')
        .setMaxWidth("500px"))
      .addTo(map);
  });
  $(document.getElementById('footerElement')).LoadingOverlay("hide", true);
}
